var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeEmailOutline = function SvgCassiopeiaBadgeEmailOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 50,
    viewBox: "0 0 9.525 13.229",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 9.26,
    height: 6.594,
    x: -30.872,
    y: 54.669,
    rx: 0.688,
    ry: 0.688,
    style: {
      fill: "#fff",
      fillOpacity: 0.501961,
      stroke: "#000",
      strokeWidth: 0.264583,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: ".793748,.264583",
      strokeDashoffset: 1.48166,
      strokeOpacity: 0.501961
    },
    transform: "translate(31.005 -51.352)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeEmailOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-email-outline.f1e2f147d6a1775b28d684f5eb894335.svg";